export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["CONSULTATION"] = "C";
    ScheduleType["EXAM"] = "E";
    ScheduleType["SERVICE"] = "S";
})(ScheduleType || (ScheduleType = {}));
//# sourceMappingURL=pseudonym-suggestion-card-item-type.js.map